
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      // eslint-disable-next-line no-undef
      EBWidgets.createWidget({
        // Required
        widgetType: this.blok?.type,
        eventId: this.blok?.eventId,
        iframeContainerId: this.blok?.iframeContainerId,
        // onOrderComplete: () => console.log('test'), // Method called when an order has successfully completed
      })
    })
  },
}
